import * as jose from 'jose';

import { AUTH_AUDIENCE, AUTH_ISSUER } from './config';
import type { AuthenticationTokenPayload } from './types';

export interface CreateAuthTokenOptions {
    /**
     * Time in seconds before the token expires.
     * Defaults to 6 hours.
     */
    expiresIn?: number;
}

/**
 * Create an authentication token.
 */
export async function createAuthToken(
    token: AuthenticationTokenPayload,
    secretStr: string,
    options: CreateAuthTokenOptions = {}
): Promise<string> {
    const secret = new TextEncoder().encode(secretStr);
    const alg = 'HS256';

    const jwt = await new jose.SignJWT(
        // @ts-ignore
        token as jose.JWTPayload
    )
        .setProtectedHeader({ alg })
        .setIssuedAt()
        .setIssuer(AUTH_ISSUER)
        .setAudience(AUTH_AUDIENCE)
        .setExpirationTime(`${options.expiresIn ?? 6 * 60 * 60}s`)
        .sign(secret);

    return jwt;
}

/**
 * Create a token that can be used to force the Hive version when passed to ingress/other Hive services.
 */
export async function createVersionOverrideToken(
    version: 'v1' | 'v2',
    secretStr: string
): Promise<string> {
    const secret = new TextEncoder().encode(secretStr);
    const alg = 'HS256';

    const jwt = await new jose.SignJWT({
        ver: version,
    })
        .setProtectedHeader({ alg })
        .setIssuedAt()
        .setIssuer(AUTH_ISSUER)
        .setAudience(AUTH_AUDIENCE)
        .sign(secret);

    return jwt;
}
